import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Table } from "antd";

const vehicleStatusDropdown = [
  {
    text: "Active",
    value: "ACTIVE",
  },
  {
    text: "Inactive",
    value: "INACTIVE",
  },
];

const VehicleTable = ({
  tableData,
  onSelectVehicle,
  paginationDetails,
  updatePaginationDetails,
}) => {
  const handlePageChange = (pagination, filters, sorter) => {
    updatePaginationDetails({
      ...paginationDetails,
      current: pagination.current,
      pageSize: pagination.pageSize,
      ...filters,
      ...sorter,
    });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        className="filter-dropdown-card"
        data-testid="filter-dropdown"
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          allowClear
          data-testid={dataIndex + "-search-input"}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={confirm}
          style={{
            width: "250px",
            marginBottom: 8,
          }}
        />
        <Space>
          <Button
            type="link"
            size="small"
            data-testid="search-filter-close-btn"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
          <Button
            onClick={clearFilters}
            size="small"
            className="table-filter-btn"
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            className="table-filter-btn"
          >
            Search
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        data-testid={dataIndex + "-search-icon"}
        style={{
          color: filtered ? "#1677ff" : undefined,
          fontSize: "16px",
        }}
      />
    ),
  });

  const columns = [
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      className: "pl1",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "imei" && paginationDetails?.order,
      sorter: true,
      ...getColumnSearchProps("imei"),
    },
    {
      title: "Model Name",
      dataIndex: "modelName",
      key: "modelName",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "modelName" && paginationDetails?.order,
      sorter: true,
      ...getColumnSearchProps("modelName"),
    },
    {
      title: "Manufacturer Date",
      dataIndex: "mfrDate",
      key: "mfrDate",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "mfrDate" && paginationDetails?.order,
      sorter: true,
    },
    {
      title: "Net Weight",
      dataIndex: "netWeight",
      key: "netWeight",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "netWeight" && paginationDetails?.order,
      sorter: true,
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "color" && paginationDetails?.order,
      sorter: true,
    },
    {
      title: "Chassis No",
      dataIndex: "chassisNumber",
      key: "chassisNumber",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "chassisNumber" &&
        paginationDetails?.order,
      sorter: true,
      ...getColumnSearchProps("chassisNumber"),
    },
    {
      title: "Status",
      dataIndex: "operationStatus",
      key: "operationStatus",
      sortDirections: ["ascend", "descend"],
      showSorterTooltip: false,
      sortOrder:
        paginationDetails?.field === "operationStatus" &&
        paginationDetails?.order,
      sorter: true,
      filters: vehicleStatusDropdown,
      filterMultiple: false,
    },
  ];

  return (
    <Table
      data-testid="vehicle-info-table"
      columns={columns}
      dataSource={tableData.List}
      rowKey={(record) => record.imei}
      scroll={{ x: "100%" }}
      onChange={handlePageChange}
      className="vehicle-info-table"
      rowClassName="cursor-pointer"
      onRow={(record, rowIndex) => {
        return {
          onClick: () => onSelectVehicle(record), // click header row
        };
      }}
      pagination={{
        current: paginationDetails.current,
        pageSize: paginationDetails.pageSize,
        total: tableData.totalElements,
        showSizeChanger: false,
        showQuickJumper: false,
        hideOnSinglePage: true,
      }}
    />
  );
};
export default VehicleTable;
